import axios from "axios";

export const vehiculoService = {
  // ============= FUNCIÓN BASE =============
  async apiCall(endpoint, token) {
    try {
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // ============= MÉTODO PRINCIPAL UNIFICADO =============

  // Obtener todos los datos de vehículo (registro, deudas, multas)
  async getVehiculo(
    idvehiculo,
    token,
    conexion,
    fechaSistema,
    espiritu,
    factorCambio,
  ) {
    // 1. Obtener datos del vehículo
    const vehiculoEndpoint = `${conexion}/api/consulta/modeli?campos=*&id=${idvehiculo}&nomtab=vehiculo&nomid=idvehiculo`;
    const vehiculoResponse = await this.apiCall(vehiculoEndpoint, token);

    if (vehiculoResponse.status !== 200 || !vehiculoResponse.data?.idvehiculo) {
      throw new Error("No se encontró el vehículo");
    }

    const vehiculoData = vehiculoResponse.data;

    // 2. Obtener deudas del vehículo
    const deudaEndpoint = `${conexion}/api/vehiculo/deudavehiculo?idvehiculo=${idvehiculo}&fecha=${fechaSistema}&espiritu=${espiritu}`;
    const deudaResponse = await this.apiCall(deudaEndpoint, token);

    // 3. Obtener multas del vehículo
    const campos = "*";
    const tabla = "multa";
    const nombreid = "idcontribuyente";
    const nombreid2 = "tablacontribuyente";
    const valorid2 = "vehiculo";
    const nombreid3 = "tipoimpuesto";
    const valorid3 = "IMPUESTOS DE VEHICULOS";
    const multasEndpoint = `${conexion}/api/consulta/modeli3string?campos=${campos}&id=${idvehiculo}&nomtab=${tabla}&nomid=${nombreid}&nomid2=${nombreid2}&id2=${valorid2}&nomid3=${nombreid3}&id3=${valorid3}`;
    const multasResponse = await this.apiCall(multasEndpoint, token);

    // 4. Obtener factor de cambio
    let factorCambioValor = factorCambio;
    if (!factorCambioValor) {
      try {
        const factorEndpoint = `${conexion}/api/vehiculo/factorcambio`;
        const factorResponse = await this.apiCall(factorEndpoint, token);
        if (factorResponse.status === 200) {
          factorCambioValor = factorResponse.data.valor;
        }
      } catch (error) {
        console.error("Error al obtener factor cambio:", error);
      }
    }

    // 5. Retornar todos los datos mapeados
    return {
      status: 200,
      mappedData: {
        vehiculo: this.mapVehiculoData(vehiculoData),
        deudas: this.mapDeudasVehiculo(
          deudaResponse.data || [],
          factorCambioValor,
        ),
        multas: this.mapMultasVehiculo(multasResponse.data || []),
        factorCambio: factorCambioValor,
      },
    };
  },

  // ============= MÉTODOS ADICIONALES =============

  // Obtener lista de vehículos
  async getVehiculos(token, conexion) {
    const campos =
      "placa, ritm, TRIM(nombrepropie) AS nombrepropie, idvehiculo";
    const nomtab = "vehiculo";
    const orden = "idvehiculo";
    const endpoint = `${conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    return await this.apiCall(endpoint, token);
  },

  // Obtener factor de cambio
  async getFactorCambio(token, conexion) {
    const endpoint = `${conexion}/api/vehiculo/factorcambio`;
    return await this.apiCall(endpoint, token);
  },

  // ============= MAPEADORES =============

  // Mapear datos del vehículo
  mapVehiculoData(data) {
    if (!data) return null;
    return {
      idvehiculo: data.idvehiculo,
      placa: data.placa?.trim().replace(/\s+/g, " ") || "",
      ritm: data.ritm?.trim().replace(/\s+/g, " ") || "",
      nombrepropie: data.nombrepropie?.trim().replace(/\s+/g, " ") || "",
      serialcarroceria: data.serialcarroceria,
      serialmotor: data.serialmotor,
      modelo: data.modelo,
      marca: data.marca,
      anio: data.anio,
      color: data.color,
      tipovehiculo: data.tipovehiculo,
      usuvehiculo: data.usuvehiculo,
      status: data.status,
    };
  },

  // Mapear deudas del vehículo
  mapDeudasVehiculo(data, factorCambio = 1) {
    if (!data || data.length === 0) return { deu: [], his: [] };

    const deu = [];
    const his = [];

    data.forEach((item) => {
      const deudaBase = {
        anio: item.anio,
        mes: item.mes?.replace(/'/g, ""),
        monto: (item.mondeu || 0) * factorCambio,
        intereses: item.intmoradeu || 0,
        recargo: item.recargodeu || 0,
        descuento: item.mondescue || 0,
        totalperi: item.subtotal,
        status: item.estatus,
        idfac: item.idfact,
        nummes: item.nmes,
        estatusfac: item.estatusfac,
        tipotransaccion: item.tipotransaccion,
      };

      if (item.fechapago === null) {
        deu.push(deudaBase);
      } else {
        his.push({
          ...deudaBase,
          multa: item.multa || 0,
          recibo: item.numreci,
          fechapago: item.fechapago,
        });
      }
    });

    return { deu, his };
  },

  // Mapear multas del vehículo
  mapMultasVehiculo(data) {
    if (!data || data.length === 0) return [];
    return data.map((multa) => ({
      idmulta: multa.idmulta,
      fechamulta: multa.fechamulta,
      descripcion: multa.descripcion,
      concepto: multa.concepto,
      monto: multa.monto,
      cancelada: multa.cancelada,
    }));
  },
};
